module.exports = __webpack_public_path__ + "img/138-bahrain.49837f36.svg";